import { useToggleState } from '../../../../../utils/common/dataTypes/boolean.js';

var usePollVotersModal = function (data) {
    var _a = useToggleState(false), isOpen = _a[0], open = _a[1], close = _a[2];
    var _b = data.metadata, _c = _b === void 0 ? {} : _b, _d = _c.poll_data, _e = _d === void 0 ? {} : _d, _f = _e.options, options = _f === void 0 ? [] : _f, pollUuid = _c.poll_uuid;
    var totalVotes = options.reduce(function (total, _a) {
        var votes = _a.votes;
        return total + votes;
    }, 0);
    var formattedOptions = options.map(function (currentOption) {
        var option = currentOption.option, uuid = currentOption.uuid, votes = currentOption.votes;
        var percentage = totalVotes ? Math.round((votes / totalVotes) * 100) : 0;
        return { option: option, uuid: uuid, percentage: percentage, votes: votes };
    });
    return {
        isOpen: isOpen,
        data: {
            poll_uuid: pollUuid,
            total_votes: totalVotes,
            options: formattedOptions,
        },
        open: open,
        close: close,
    };
};

export { usePollVotersModal };
//# sourceMappingURL=usePollVotersModal.js.map
